import commonService from './common-service';

class ReturnService {

  async getReturns(date1 = '', date2 = '') {
    try {
      if (date1 === '' || date2 === '') {
        date1 = '2020-01-01';
        date2 = new Date().toLocaleDateString('en-CA');
      }
      const response = await commonService.getFromServer('Returns?d1=' + date1 + '&d2=' + date2, {});
      if (response) {
        return response;
      } else {
        throw new Error('Error retrieving details. Please contact administrator.');
      }
    } catch (e) {
      throw new Error(e.message);
    }
  }

  async addReturn(returnParams) {
    try {
      const response = await commonService.postToServer('Returns', returnParams);
      if (response) {
        return response;
      } else {
        throw new Error('Error retrieving details. Please contact administrator.');
      }
    } catch (e) {
      throw new Error(e.message);
    }
  }
}

export default new ReturnService();
